import { RefObject, useCallback } from 'react'

type UseHandleClickOutside = {
  pickerModalRef: RefObject<any>
  action: () => void
}

export const useHandleClickOutside = ({
  pickerModalRef,
  action,
}: UseHandleClickOutside) => {
  return useCallback(
    (event: any) => {
      if (
        pickerModalRef?.current &&
        !pickerModalRef.current.contains(event.target)
      ) {
        action()
      }
    },
    [pickerModalRef, action],
  )
}
